export default __webpack_public_path__ + "static/media/blackBack1.de3dc47e.png";